var error = {
  translation: {
    error: {
      coreNotFound: 'Kern-Einstellungen konnten nicht geladen werden',
      domainNotAllowed: 'Registrierung mit E-Mail von dieser Domain nicht möglich',
      emailAlreadyInUse: 'E-Mail bereits vergeben',
      insufficientPermissions: 'Unzureichende Berechtigungen',
      invalidCurrentPassword: 'Aktuelles Passwort ungültig',
      invalidPermissions: 'Bitte wählen Sie mindestens eine Berechtigung',
      invalidUsernameOrPassword: 'Ungültiger Benutzername oder Passwort',
      localRegistrationDisabled: 'Lokale Benutzerregistrierung wurde vom Administrator deaktiviert',
      noInternetConnection: 'Keine Internetverbindung',
      noOidcProfileFound: 'Kein OIDC-Profil gefunden',
      policyNotAccepted: 'Bitte akzeptiere die Nutzungsbedingungen und Datenschutzerklärung',
      registrationDisabled: 'Die Benutzerregistrierung wurde vom Administrator deaktiviert',
      serverConnectionFailed: 'Serververbindung fehlgeschlagen',
      ssoRegistrationDisabled: 'SSO-Registrierung wurde vom Administrator deaktiviert',
      tooManyFailedAttempts: 'Zu viele fehlgeschlagene Versuche - bitte später erneut versuchen',
      unknownError: 'Unbekannter Fehler, bitte später erneut versuchen',
      usernameAlreadyInUse: 'Benutzername bereits vergeben',
      weakPassword: 'Bitte ein stärkeres Passwort verwenden',
    },
  },
};

export { error as default };
